import $ from "jquery";
import "jquery-mask-plugin";
import { countryState } from "./countryState";
import { dataaccess } from "../dataaccess/dataContext";
import { ordersShippingAddress } from "./ordersShippingAddress";

function init() {
    if (window.location.hash !== "") {
        //if location hash was set
        $("#ordersNav a[href='" + window.location.hash + "']").tab("show"); //show proper tab. Used to show Purchase History on refresh after purchase
        window.location.hash = ""; //reset hash
    }
    populateProgram(); //See Method Definition
    emptyModalEventHandler("#Checkout"); //See Method Definition
    emptyModalEventHandler("#AddToCart"); //See Method Definition
    //DOM Events Using $(document).on() because as a partial is refreshed,
    //if its a direct reference to an element, it will no longer fire the event

    $(document).on("click", "#confirmShippingAddressBtn", function () {
        const $form = $("#shippingAddressForm");
        $.validator.unobtrusive.parse($form);

        if ($form.valid()) {
            $("#ConfirmAddressSpinner").modal("show");
            
            const params = {
                "contentType": dataaccess.contentType.APPLICATION_X_WWW_FORM_URLENCODED,
                "data": $form.serialize(),
                "url": $form.attr("action")
            };

            dataaccess.post(params).done(function(result) {
                $("#ConfirmAddressSpinner").modal("hide");
                $("#orderPartial").html(result);
                $("#programDiv").show();
            });
        }
    });

    $(".program-select").change(function () {
        //Calls Orders Controller to get Product by Program Selected in program-select
        const program = $(this).val();
        dataaccess.get({ url: "/Orders/GetProductsByProgram/" + program }).done(function(res) {
            $("#productPartial").html(res);
        });
    });

    $(document).on("change", "#ShippingOptions", function () {
        shippingOptionsChange();
    });

    $(document).on("show.bs.modal", "#AddToCart", function (e) {
        //calls orders controller to get contents of modal
        const button = $(e.relatedTarget);
        const productId = button.attr("data-productId");
        dataaccess.get({ url: "/Orders/OpenAddToCartModal/" + productId }).done(function(res) {
            $("#AddToCart")
                .find(".modal-content")
                .html(res);
            $.validator.unobtrusive.parse($("#cart-form"));
            $("#quantity").mask("0#");
        });
    });

    $(document).on("click", ".quantity-plus", function () {
        let quantity = parseInt($("#quantity").val());
        if (isNaN(quantity)) quantity = 0;
        $("#quantity").val(quantity + 1); //increase quantity
    });

    $(document).on("click", ".quantity-minus", function () {
        const quantity = parseInt($("#quantity").val());
        if (quantity > 1) $("#quantity").val(quantity - 1); //decrease quantity
    });

    $(document).on("submit", "#cart-form", function (e) {
        e.preventDefault();
        const $form = $(this);
        let licenseType = "X";
        let siteId = "0";
        if ($form.valid()) {
            if ($("#licenseTypeIndividual").length > 0) {
                licenseType = $("input[name='LicenseType']:checked").val();
                siteId = $("#siteId").val();
                if (licenseType == "S" && parseInt(siteId) < 1) {
                    alert("You must choose a site if you have chosen a site license");
                    return;
                }
            }
            updateOrderline($("#productId").val(), $("#quantity").val(), licenseType, siteId);
        }
    });

    $(document).on("click", ".delete-product", function () {
        //passing quantity of 0 lets endpoint know to remove before sending to Aptify
        updateOrderline($(this).attr("data-productId"), 0, "", 0);
    });

    $(document).on("show.bs.modal", "#Checkout", function () {
        //calls orders controller to get contents of modal
        dataaccess.get({ url: "/Orders/OpenCheckoutModal" }).done(function(res) {
            $("#Checkout")
                .find(".modal-content")
                .html(res);
            $("#Checkout").modal("show");
            $.validator.unobtrusive.parse("#Checkout");
            $(":input[mask]").each(function() {
                $(this).mask($(this).attr("mask"));
            }); //since partial need to reinitialize the input masks
            shippingOptionsChange();
            initCheckoutInputMasks();

            ordersShippingAddress.init();
            countryState.init();
            const countryIsoCode = $("#txtSelectedCountryCodeDisabled").val();
            countryState.populateStatesSelect("#billing-address-state", "#txtNonNaState", countryIsoCode).done(function() {
                const stateAbbreviation = $("#txtSelectedStateIdDisabled").val();
                $("#selectPersonState").val(stateAbbreviation);
                $("#txtNonNaState").val($("#txtSelectedStateAbbreviationDisabled").val());
            });
        });
    });

    $(document).on("click", "input[data-name=paymentType]", function () {
        //Facilitates the changing of tabs in payment type selection.
        //Like this to guarantee that a payment option is always shown. Using bootstrap allowed for an option to be closed by clicking again.
        $(".tab-content > .card-block").hide();
        $(".tab-content > #" + $(this).data("id")).show();
    });

    $(document).on("click", "#ConfirmPurchaseBtn", function (e) {
        e.preventDefault();
        const $form = $("#CheckoutOrderForm");
        $.validator.unobtrusive.parse($form);
        
        if ($form.valid()) {
            $("#ConfirmPurchaseBtn").attr("disabled", "disabled");
            $("#OrderProcessMessage").show();
            $("#PaymentErrorMessage").hide();

            const params = {
                "contentType": dataaccess.contentType.APPLICATION_X_WWW_FORM_URLENCODED,
                "data": $form.serialize(),
                "url": $form.attr("action"),
                "successMsg": "Your Order has been placed successfully."
            };
            
            dataaccess.post(params).done(function(result) {
                window.location.hash = "purchaseHistory"; //tells on page load to redirect to purchase history
                window.location.reload(); //reload page after order successful
            }).fail(function(xhr, status, error) {
                if (xhr.status === 400) {
                    $("#PaymentErrorMessage").show();
                } else {
                    $("#Checkout .close").click();
                }
            }).always(function() {
                $("#ConfirmPurchaseBtn").removeAttr("disabled");
                $("#OrderProcessMessage").hide();
            });
        }
    });

    $(document).on("change", "#Payment_PaymentTypeId", function() {
        $("#paymentDiv .payinfo").prop("disabled", true);
        $("#paymentDiv .payinfo-" + $(this).val()).prop("disabled", false);
    });

    $(document).on("change", "#licenseTypeIndividual", function() {
        if ($(this).is(":checked")) {
            $("#_addToCartLicenseSiteId").addClass("hidden");
            $("#siteId").val(0);
        }
    });

    $(document).on("change", "#licenseTypeSite", function() {
        if ($(this).is(":checked")) {
            $("#_addToCartLicenseSiteId").removeClass("hidden");
            $("#siteId").val(0);
        }
    });

    $.validator.unobtrusive.parse("#CheckoutOrderForm");
}
function shippingOptionsChange() {
    //Calls Orders Controller to get shipment type
    if ($("#ShippingOptions").val() !== "") {
        const shipmentType = $("#ShippingOptions option:selected").val();
        dataaccess.get({ url: "/Orders/UpdateShipmentType/" + shipmentType }).done(function(res) {
            $("#checkoutCartContainer").html(res);
        });
    }
}
function emptyModalEventHandler(jQueryIdentifier) {
    //empties the modal when a modal is closed so no information is retained. Ensures that product quantities are accurate
    $(document).on("hidden.bs.modal", jQueryIdentifier, function() {
        $(this).removeData("bs.modal");
        $(jQueryIdentifier + " .modal-content").empty();
    });
}
function updateOrderline(productId, quantity, licenseType, siteId) {
    //Updates the Orderline and refreshes Order with Aptify
    const data = { quantity: quantity, productId: productId, licenseType: licenseType, siteId: siteId };
    const params = { data: data, url: "/Orders/UpdateOrderLine" };
    $("#AddToCart .close").click();
    $("#AddToCartLoading").show();
    dataaccess.post(params).done(function(data) {
        $("#AddToCartLoading").hide();
        $("#orderPartial").html(data);
    });
}
function populateProgram() {
    //Populates the Program Dropdown with Programs from ATLS DB
    const $program = $("#programDdl");
    $program.find("option").remove();
    dataaccess.get({ url: "/Course/program/" }).done(function(result) {
        $.each(result, function () {
            const optionTag = this.default ? "<option selected>" : "<option>";
            $program.append($(optionTag + this.description + "</option>"));
        });
    });
}

function initCheckoutInputMasks() {
    $("#Payment_CardExpirationMonth").mask("00");
    
    $("#Payment_CardExpirationYear").mask("abcd", {
        clearIfNotMatch: true,
        translation: {
            "a": {
                pattern: /[2]/, optional: false
            },
            "b": {
                pattern: /[0]/, optional: false
            },
            "c": {
                pattern: /[0-9]/, optional: false
            },
            "d": {
                pattern: /[0-9]/, optional: false
            }
        }
    });
}

export const orders = {
    init: init
};